import { PossibleValuesHierarchy } from "./possible-values-hierarchy";

export class Country {
  constructor(
    public studyId: number | null,
    public studyTemplateId: number | null,
    public studyCountryClassificationId: number | null,
    public countryClassificationId: number | null,
    public required: boolean | null,
    public tupleVersion: number | null,
    public possibleValues?: PossibleValuesHierarchy[] | null
) { }
}
